import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa3ae8ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 이런 것들이 궁금하시죠? ")
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "question-area" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Q", -1))
const _hoisted_5 = {
  key: 0,
  class: "answer"
}

import { ref, onMounted } from 'vue' 
import Text from '@/components/common/TextComponent.vue'
import { FONT_WEIGHT, COLOR_SET } from '@/styles/variables'
import UpAngleBracket from '@/styles/icon/UpAngleBracket.vue'
import DownAngleBracket from '@/styles/icon/DownAngleBracket.vue'

import { questions, QuestionProps } from '../constants/questions'
import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingFQA',
  setup(__props) {

const questionList = ref<QuestionProps[]>(questions)
const wrapper = ref()
const showAnimation = ref(false)

const handleSelect = (target: QuestionProps) => {
  target.isSelected = !target.isSelected 
}

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createVNode(Text, {
      size: "64px",
      "mobile-size": "30px",
      "line-height": "1.25",
      weight: _unref(FONT_WEIGHT).bold,
      "word-break": "keep-all",
      "text-align": "center",
      class: _normalizeClass(["title animation-show", { show: showAnimation.value }])
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["weight", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["questions animation-show delay", { show: showAnimation.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["question", { selected: item.isSelected }]),
          onClick: ($event: any) => (handleSelect(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Text, {
              class: "question-text",
              size: "28px",
              "mobile-size": "16px",
              "mobile-width": "250px",
              "mobile-margin": "0 0 0 15px"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(item.question), 1)
              ]),
              _: 2
            }, 1024),
            (!item.isSelected)
              ? (_openBlock(), _createBlock(DownAngleBracket, {
                  key: 0,
                  width: 24,
                  height: 14,
                  "mobile-width": 18,
                  "mobile-height": 8,
                  color: _unref(COLOR_SET).gray01
                }, null, 8, ["color"]))
              : _createCommentVNode("", true),
            (item.isSelected)
              ? (_openBlock(), _createBlock(UpAngleBracket, {
                  key: 1,
                  width: 24,
                  height: 14,
                  "mobile-width": 18,
                  "mobile-height": 8,
                  color: _unref(COLOR_SET).gray01
                }, null, 8, ["color"]))
              : _createCommentVNode("", true)
          ]),
          (item.isSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Text, {
                  size: "24px",
                  "mobile-size": "14px",
                  weight: _unref(FONT_WEIGHT).bold,
                  "word-break": "keep-all",
                  "white-space": "pre-line"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.answerTitle), 1)
                  ]),
                  _: 2
                }, 1032, ["weight"]),
                _createVNode(Text, {
                  size: "24px",
                  "mobile-size": "14px",
                  "word-break": "keep-all"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.answer), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ], 2)
  ], 512))
}
}

})